// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Game Component CSS Module
 * Optimized for high-performance rendering with many game cards
 */
.SWrXvOeZtKiUY9SlGEI4 {
  position: relative;
  border-radius: var(--border-radius-for-game-cards, 5px);
  cursor: pointer;
  aspect-ratio: var(--game-card-aspect-ratio);
  /* Vertical aspect ratio */
  opacity: 0;
  animation: hUZYmnaeybzIhvAD2rK_ 0.4s ease-out forwards;
  will-change: opacity;
  flex: 0 0 auto;
  container-type: inline-size;
  /* Mobile-first responsive sizing - matches theme.layout.gameCard */
  width: 100%;
  max-width: 132px;
  height: auto;
  flex-shrink: 0;
  /* Touch optimizations */
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}
.SWrXvOeZtKiUY9SlGEI4[data-view='single'] {
  width: 100%;
  max-width: 100%;
  height: 100%;
  max-height: 100%;
}
/* Grid span classes */
.SWrXvOeZtKiUY9SlGEI4[data-cols="1"] {
  grid-column-start: span 1;
}
.SWrXvOeZtKiUY9SlGEI4[data-cols="2"] {
  grid-column-start: span 2;
}
.SWrXvOeZtKiUY9SlGEI4[data-rows="1"] {
  grid-row-start: span 1;
}
.SWrXvOeZtKiUY9SlGEI4[data-rows="2"] {
  grid-row-start: span 2;
}
/* Horizontal game variant */
/* fallow-ignore-next-line unused-export */
.SWrXvOeZtKiUY9SlGEI4.sF7diwF0Rp9kxiM7_Uvg {
  aspect-ratio: 1 / 0.42;
}
/*.gameCard>picture>img {*/
/*  border-radius: var(--border-radius-for-game-cards, 5px);*/
/*  width: 100%;*/
/*  height: 100%;*/
/*  pointer-events: none;*/
/*  vertical-align: middle;*/
/*  object-fit: cover;*/
/*  !* animation: fadeIn 0.3s ease-in-out; *!*/
/*}*/
.xxL3hJGy7llV76Q1Duk8 {
  position: absolute;
  top: 0;
  left: 0;
  width: var(--badge-plate-width, 40%);
  height: auto;
  min-height: 1px;
  /*prevents image not being displayed on some devices*/
  border-radius: var(--border-radius-for-game-cards, 5px) 0 0 0;
  pointer-events: none;
}
/* Remove animation from jackpot badge images */
/* .gameCard .badge,
.gameCard .badge_plate {
  animation: none !important;
} */
@keyframes hUZYmnaeybzIhvAD2rK_ {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
/* fallow-ignore-next-line unused-export */
.SWrXvOeZtKiUY9SlGEI4 .current_players_icon {
  border-radius: 0;
  object-fit: contain;
}
@media (min-width: 1025px) {
  .SWrXvOeZtKiUY9SlGEI4 .current_players_icon {
    width: 13px;
    height: 17px;
  }
}
/* Responsive card sizes */
@media (max-width: 500px) and (min-width: 375px) {
  .SWrXvOeZtKiUY9SlGEI4[data-view='multi'] {
    max-width: 34.2vw;
  }
}
@media (min-width: 501px) {
  .SWrXvOeZtKiUY9SlGEI4[data-view='multi'] {
    max-width: 164px;
  }
}
@media (min-width: 768px) {
  .SWrXvOeZtKiUY9SlGEI4[data-view='multi'] {
    max-width: 164px;
  }
}
@media (min-width: 1026px) {
  .SWrXvOeZtKiUY9SlGEI4[data-view='multi'] {
    max-width: 246px;
  }
}
/* Touch feedback on mobile */
@media (hover: none) and (pointer: coarse) {
  .SWrXvOeZtKiUY9SlGEI4:active {
    transform: scale(0.98);
    transition: transform 0.1s ease;
  }
}
/* Hover effects only on devices with a mouse/trackpad - completely disabled for all touch devices */
@media (hover: hover) and (pointer: fine) {
  .SWrXvOeZtKiUY9SlGEI4:hover .iqhQ4IVne6kk2sNJtguP {
    visibility: hidden;
  }
  .SWrXvOeZtKiUY9SlGEI4:hover .h2jIUYo7D5eIR4uAlSZQ {
    display: flex;
  }
  .SWrXvOeZtKiUY9SlGEI4:hover::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.75);
    border-radius: var(--border-radius-for-game-cards, 5px);
    z-index: 1;
    pointer-events: none;
  }
}
/* Ensure hover effects are completely disabled on touch devices regardless of screen size */
@media (hover: none) and (pointer: coarse) {
  .SWrXvOeZtKiUY9SlGEI4:hover .iqhQ4IVne6kk2sNJtguP {
    visibility: visible !important;
  }
  .SWrXvOeZtKiUY9SlGEI4:hover .h2jIUYo7D5eIR4uAlSZQ {
    display: none !important;
  }
  .SWrXvOeZtKiUY9SlGEI4:hover::before {
    display: none !important;
  }
}
.iqhQ4IVne6kk2sNJtguP {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  pointer-events: none;
}
.zyyCgEClZbpZLenFJvhz {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 20px;
  /* default for single view */
  width: 100%;
  height: 18px;
  font-family: var(--font-family-numeric, 'San Francisco Bold');
  font-weight: 700;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  pointer-events: none;
  text-align: start;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #fff;
  padding: 2px 4px;
  background: linear-gradient(180deg, #00000000 0%, #00000080 100%);
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.zyyCgEClZbpZLenFJvhz::-webkit-scrollbar {
  display: none;
}
.zyyCgEClZbpZLenFJvhz.W3RgBWG8kPvt7kD8qx_A {
  bottom: var(--jp-bottom-band-height, 32px);
}
@media (min-height: 500px) {
  [data-view='single'][data-section='pickRandom'] .zyyCgEClZbpZLenFJvhz.W3RgBWG8kPvt7kD8qx_A {
    bottom: 34px;
    height: 27px;
    padding: 2px 8px;
  }
}
@media (min-width: 1025px) {
  [data-game-card-size="compact"] .zyyCgEClZbpZLenFJvhz.W3RgBWG8kPvt7kD8qx_A {
    height: 18px;
  }
}
.zyyCgEClZbpZLenFJvhz.bzWG7nK24YaeCjYEMAv9 {
  bottom: 0;
  border-radius: 0 0 var(--border-radius-for-game-cards, 5px) var(--border-radius-for-game-cards, 5px);
}
/* Responsive breakpoints - matches theme.layout.gameCard */
@media (max-width: 1024px) {
  .zyyCgEClZbpZLenFJvhz.W3RgBWG8kPvt7kD8qx_A[data-view='multi'] {
    bottom: 24px;
  }
}
@media (min-width: 320px) {
  .zyyCgEClZbpZLenFJvhz.W3RgBWG8kPvt7kD8qx_A[data-view='single'] {
    bottom: 20px;
  }
}
@media (min-width: 430px) {
  .zyyCgEClZbpZLenFJvhz[data-view='multi'] {
    font-size: 12px;
    padding: 2px 6px;
  }
  .zyyCgEClZbpZLenFJvhz.W3RgBWG8kPvt7kD8qx_A[data-view='single'] {
    bottom: 24px;
  }
}
@media (orientation: landscape) and (max-height: 430px) {
  .zyyCgEClZbpZLenFJvhz[data-view='multi'] {
    height: 18px;
  }
}
@media (min-width: 1026px) {
  .zyyCgEClZbpZLenFJvhz[data-view='multi'] {
    font-size: 13px;
    padding: 4px 10px;
    height: 26px;
  }
  .zyyCgEClZbpZLenFJvhz[data-view='single'] {
    height: 42px;
  }
}
/* Smaller font for search cards when card is narrow */
@container (max-width: 120px) {
  .zyyCgEClZbpZLenFJvhz[data-section='search'] {
    --game-info-bar-font-size: 11px;
  }
  .zyyCgEClZbpZLenFJvhz[data-section='search'] .current_players_icon {
    height: 9px;
    width: 7px;
  }
}
/* High performance animations */
@media (prefers-reduced-motion: no-preference) {
  .SWrXvOeZtKiUY9SlGEI4[data-view='multi'] {
    will-change: transform;
  }
}
/* POC animated lobby (?fx=1): the flag also drops the two permanent compositor layers above
   (will-change: opacity on every card, will-change: transform on multi-view cards) so the phone
   can be A/B'd with and without them. The fx one-shots keep the stock fadeIn at index 0 of the
   animation list (same name, same timing -> never restarted) and append a second, finite animation. */
html[data-fx='1'] .SWrXvOeZtKiUY9SlGEI4 {
  will-change: auto;
}
@media (prefers-reduced-motion: no-preference) {
  html[data-fx='1'] .SWrXvOeZtKiUY9SlGEI4[data-view='multi'] {
    will-change: auto;
  }
}
/* First-load reveal / view switch (shared/effects): while html[data-fx-stagger] is stamped, the first
   8 cards of the first 3 children of the section container rise in with a 30 ms stagger. The stock
   fadeIn keeps its exact values at index 0 (comma lists map per animation), the rise is appended. */
html[data-fx='1'][data-fx-stagger] [data-section-container] > :nth-child(-n + 3) :nth-child(-n + 8) > .SWrXvOeZtKiUY9SlGEI4 {
  animation-name: hUZYmnaeybzIhvAD2rK_, ssytMS28JRKheru3h3NK;
  animation-duration: 0.4s, 0.42s;
  animation-timing-function: ease-out, cubic-bezier(0.2, 0.8, 0.2, 1);
  animation-fill-mode: forwards, both;
  animation-delay: 0s, calc(var(--fx-i, 0) * 30ms + 350ms);
}
html[data-fx-stagger] :nth-child(2) > .SWrXvOeZtKiUY9SlGEI4 {
  --fx-i: 1;
}
html[data-fx-stagger] :nth-child(3) > .SWrXvOeZtKiUY9SlGEI4 {
  --fx-i: 2;
}
html[data-fx-stagger] :nth-child(4) > .SWrXvOeZtKiUY9SlGEI4 {
  --fx-i: 3;
}
html[data-fx-stagger] :nth-child(5) > .SWrXvOeZtKiUY9SlGEI4 {
  --fx-i: 4;
}
html[data-fx-stagger] :nth-child(6) > .SWrXvOeZtKiUY9SlGEI4 {
  --fx-i: 5;
}
html[data-fx-stagger] :nth-child(7) > .SWrXvOeZtKiUY9SlGEI4 {
  --fx-i: 6;
}
html[data-fx-stagger] :nth-child(8) > .SWrXvOeZtKiUY9SlGEI4 {
  --fx-i: 7;
}
/* Game open (features/games/effects): press-scale, then a glow ring on ::after fades over the card. */
html[data-fx='1'] .SWrXvOeZtKiUY9SlGEI4.fx-press {
  animation-name: hUZYmnaeybzIhvAD2rK_, kwCzTGDmkPKe2uFWXQma;
  animation-duration: 0.4s, 320ms;
  animation-timing-function: ease-out, cubic-bezier(0.3, 0.7, 0.3, 1);
  animation-fill-mode: forwards, none;
  animation-delay: 0s, 0s;
}
html[data-fx='1'] .SWrXvOeZtKiUY9SlGEI4.fx-press::after {
  content: '';
  position: absolute;
  inset: 0;
  z-index: 2;
  border-radius: var(--border-radius-for-game-cards, 5px);
  box-shadow: 0 0 28px 8px rgba(255, 214, 92, 0.85), inset 0 0 0 2px rgba(255, 240, 180, 0.9);
  pointer-events: none;
  animation: B7clneUDhi8xbYCwIs2w 320ms ease-out both;
}
html[data-motion-tier='lite'] .SWrXvOeZtKiUY9SlGEI4.fx-press,
html[data-motion-tier='lite'] .SWrXvOeZtKiUY9SlGEI4.fx-press::after {
  animation-duration: 0.4s, 200ms;
}
@keyframes kwCzTGDmkPKe2uFWXQma {
  0% {
    transform: scale(1);
  }
  40% {
    transform: scale(0.94);
  }
  100% {
    transform: scale(1.03);
  }
}
@keyframes B7clneUDhi8xbYCwIs2w {
  0% {
    opacity: 0;
  }
  45% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes ssytMS28JRKheru3h3NK {
  from {
    transform: translateY(12px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
/* Disable transitions during rapid switching */
/* fallow-ignore-next-line unused-export */
.sKMsFHvUc_lSFCgVUOuW .SWrXvOeZtKiUY9SlGEI4,
.sKMsFHvUc_lSFCgVUOuW .SWrXvOeZtKiUY9SlGEI4 * {
  transition: none;
}
/* Play button - hidden by default, shown on hover */
.h2jIUYo7D5eIR4uAlSZQ {
  display: none;
}
/* PrizePop icon - positioned above tournament cup */
/* fallow-ignore-next-line unused-export */
.C56fT5PbkhCH9ZjEo4ZA {
  position: absolute;
  width: 20%;
  top: 15%;
  left: 2%;
  cursor: default;
  z-index: 5;
  object-fit: contain;
}
`, "",{"version":3,"sources":["webpack://./src/features/games/components/GameCard/Game.module.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;EACE,kBAAkB;EAClB,uDAAuD;EACvD,eAAe;EACf,2CAA2C;EAC3C,0BAA0B;EAC1B,UAAU;EACV,sDAAwC;EACxC,oBAAoB;EACpB,cAAc;EACd,2BAA2B;EAC3B,mEAAmE;EACnE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,wBAAwB;EACxB,wCAAwC;EACxC,2BAA2B;EAC3B,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;AACA,sBAAsB;AACtB;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA,4BAA4B;AAC5B,0CAA0C;AAC1C;EACE,sBAAsB;AACxB;AACA,0BAA0B;AAC1B,6DAA6D;AAC7D,iBAAiB;AACjB,kBAAkB;AAClB,0BAA0B;AAC1B,4BAA4B;AAC5B,uBAAuB;AACvB,8CAA8C;AAC9C,IAAI;AACJ;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,oCAAoC;EACpC,YAAY;EACZ,eAAe;EACf,qDAAqD;EACrD,6DAA6D;EAC7D,oBAAoB;AACtB;AACA,+CAA+C;AAC/C;;;GAGG;AACH;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA,0CAA0C;AAC1C;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;AACA,0BAA0B;AAC1B;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA,6BAA6B;AAC7B;EACE;IACE,sBAAsB;IACtB,+BAA+B;EACjC;AACF;AACA,oGAAoG;AACpG;EACE;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,+BAA+B;IAC/B,uDAAuD;IACvD,UAAU;IACV,oBAAoB;EACtB;AACF;AACA,4FAA4F;AAC5F;EACE;IACE,8BAA8B;EAChC;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;AACF;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,iEAAiE;EACjE,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;EACE,aAAa;AACf;AACA;EACE,0CAA0C;AAC5C;AACA;EACE;IACE,YAAY;IACZ,YAAY;IACZ,gBAAgB;EAClB;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE,SAAS;EACT,oGAAoG;AACtG;AACA,2DAA2D;AAC3D;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,eAAe;IACf,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;AACA,sDAAsD;AACtD;EACE;IACE,+BAA+B;EACjC;EACA;IACE,WAAW;IACX,UAAU;EACZ;AACF;AACA,gCAAgC;AAChC;EACE;IACE,sBAAsB;EACxB;AACF;AACA;;;sGAGsG;AACtG;EACE,iBAAiB;AACnB;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;;oGAEoG;AACpG;EACE,0DAAkC;EAClC,+BAA+B;EAC/B,mEAAmE;EACnE,mCAAmC;EACnC,wDAAwD;AAC1D;AACA;EACE,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA,sGAAsG;AACtG;EACE,0DAA+B;EAC/B,+BAA+B;EAC/B,mEAAmE;EACnE,mCAAmC;EACnC,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,uDAAuD;EACvD,2FAA2F;EAC3F,oBAAoB;EACpB,mDAA0C;AAC5C;AACA;;EAEE,+BAA+B;AACjC;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;AACA,+CAA+C;AAC/C,0CAA0C;AAC1C;;EAEE,gBAAgB;AAClB;AACA,oDAAoD;AACpD;EACE,aAAa;AACf;AACA,oDAAoD;AACpD,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,QAAQ;EACR,eAAe;EACf,UAAU;EACV,mBAAmB;AACrB","sourcesContent":["/**\n * Game Component CSS Module\n * Optimized for high-performance rendering with many game cards\n */\n.gameCard {\n  position: relative;\n  border-radius: var(--border-radius-for-game-cards, 5px);\n  cursor: pointer;\n  aspect-ratio: var(--game-card-aspect-ratio);\n  /* Vertical aspect ratio */\n  opacity: 0;\n  animation: fadeIn 0.4s ease-out forwards;\n  will-change: opacity;\n  flex: 0 0 auto;\n  container-type: inline-size;\n  /* Mobile-first responsive sizing - matches theme.layout.gameCard */\n  width: 100%;\n  max-width: 132px;\n  height: auto;\n  flex-shrink: 0;\n  /* Touch optimizations */\n  -webkit-tap-highlight-color: transparent;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  user-select: none;\n}\n.gameCard[data-view='single'] {\n  width: 100%;\n  max-width: 100%;\n  height: 100%;\n  max-height: 100%;\n}\n/* Grid span classes */\n.gameCard[data-cols=\"1\"] {\n  grid-column-start: span 1;\n}\n.gameCard[data-cols=\"2\"] {\n  grid-column-start: span 2;\n}\n.gameCard[data-rows=\"1\"] {\n  grid-row-start: span 1;\n}\n.gameCard[data-rows=\"2\"] {\n  grid-row-start: span 2;\n}\n/* Horizontal game variant */\n/* fallow-ignore-next-line unused-export */\n.gameCard.horizontal {\n  aspect-ratio: 1 / 0.42;\n}\n/*.gameCard>picture>img {*/\n/*  border-radius: var(--border-radius-for-game-cards, 5px);*/\n/*  width: 100%;*/\n/*  height: 100%;*/\n/*  pointer-events: none;*/\n/*  vertical-align: middle;*/\n/*  object-fit: cover;*/\n/*  !* animation: fadeIn 0.3s ease-in-out; *!*/\n/*}*/\n.badgePlate {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: var(--badge-plate-width, 40%);\n  height: auto;\n  min-height: 1px;\n  /*prevents image not being displayed on some devices*/\n  border-radius: var(--border-radius-for-game-cards, 5px) 0 0 0;\n  pointer-events: none;\n}\n/* Remove animation from jackpot badge images */\n/* .gameCard .badge,\n.gameCard .badge_plate {\n  animation: none !important;\n} */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n/* fallow-ignore-next-line unused-export */\n.gameCard :global(.current_players_icon) {\n  border-radius: 0;\n  object-fit: contain;\n}\n@media (min-width: 1025px) {\n  .gameCard :global(.current_players_icon) {\n    width: 13px;\n    height: 17px;\n  }\n}\n/* Responsive card sizes */\n@media (max-width: 500px) and (min-width: 375px) {\n  .gameCard[data-view='multi'] {\n    max-width: 34.2vw;\n  }\n}\n@media (min-width: 501px) {\n  .gameCard[data-view='multi'] {\n    max-width: 164px;\n  }\n}\n@media (min-width: 768px) {\n  .gameCard[data-view='multi'] {\n    max-width: 164px;\n  }\n}\n@media (min-width: 1026px) {\n  .gameCard[data-view='multi'] {\n    max-width: 246px;\n  }\n}\n/* Touch feedback on mobile */\n@media (hover: none) and (pointer: coarse) {\n  .gameCard:active {\n    transform: scale(0.98);\n    transition: transform 0.1s ease;\n  }\n}\n/* Hover effects only on devices with a mouse/trackpad - completely disabled for all touch devices */\n@media (hover: hover) and (pointer: fine) {\n  .gameCard:hover .gameBottomContainer {\n    visibility: hidden;\n  }\n  .gameCard:hover .playButton {\n    display: flex;\n  }\n  .gameCard:hover::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.75);\n    border-radius: var(--border-radius-for-game-cards, 5px);\n    z-index: 1;\n    pointer-events: none;\n  }\n}\n/* Ensure hover effects are completely disabled on touch devices regardless of screen size */\n@media (hover: none) and (pointer: coarse) {\n  .gameCard:hover .gameBottomContainer {\n    visibility: visible !important;\n  }\n  .gameCard:hover .playButton {\n    display: none !important;\n  }\n  .gameCard:hover::before {\n    display: none !important;\n  }\n}\n.gameBottomContainer {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  width: 100%;\n  pointer-events: none;\n}\n.gameInfoBar {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 20px;\n  /* default for single view */\n  width: 100%;\n  height: 18px;\n  font-family: var(--font-family-numeric, 'San Francisco Bold');\n  font-weight: 700;\n  font-size: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  pointer-events: none;\n  text-align: start;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: #fff;\n  padding: 2px 4px;\n  background: linear-gradient(180deg, #00000000 0%, #00000080 100%);\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n.gameInfoBar::-webkit-scrollbar {\n  display: none;\n}\n.gameInfoBar.hasJackpot {\n  bottom: var(--jp-bottom-band-height, 32px);\n}\n@media (min-height: 500px) {\n  [data-view='single'][data-section='pickRandom'] .gameInfoBar.hasJackpot {\n    bottom: 34px;\n    height: 27px;\n    padding: 2px 8px;\n  }\n}\n@media (min-width: 1025px) {\n  [data-game-card-size=\"compact\"] .gameInfoBar.hasJackpot {\n    height: 18px;\n  }\n}\n.gameInfoBar.noJackpot {\n  bottom: 0;\n  border-radius: 0 0 var(--border-radius-for-game-cards, 5px) var(--border-radius-for-game-cards, 5px);\n}\n/* Responsive breakpoints - matches theme.layout.gameCard */\n@media (max-width: 1024px) {\n  .gameInfoBar.hasJackpot[data-view='multi'] {\n    bottom: 24px;\n  }\n}\n@media (min-width: 320px) {\n  .gameInfoBar.hasJackpot[data-view='single'] {\n    bottom: 20px;\n  }\n}\n@media (min-width: 430px) {\n  .gameInfoBar[data-view='multi'] {\n    font-size: 12px;\n    padding: 2px 6px;\n  }\n  .gameInfoBar.hasJackpot[data-view='single'] {\n    bottom: 24px;\n  }\n}\n@media (orientation: landscape) and (max-height: 430px) {\n  .gameInfoBar[data-view='multi'] {\n    height: 18px;\n  }\n}\n@media (min-width: 1026px) {\n  .gameInfoBar[data-view='multi'] {\n    font-size: 13px;\n    padding: 4px 10px;\n    height: 26px;\n  }\n  .gameInfoBar[data-view='single'] {\n    height: 42px;\n  }\n}\n/* Smaller font for search cards when card is narrow */\n@container (max-width: 120px) {\n  .gameInfoBar[data-section='search'] {\n    --game-info-bar-font-size: 11px;\n  }\n  .gameInfoBar[data-section='search'] :global(.current_players_icon) {\n    height: 9px;\n    width: 7px;\n  }\n}\n/* High performance animations */\n@media (prefers-reduced-motion: no-preference) {\n  .gameCard[data-view='multi'] {\n    will-change: transform;\n  }\n}\n/* POC animated lobby (?fx=1): the flag also drops the two permanent compositor layers above\n   (will-change: opacity on every card, will-change: transform on multi-view cards) so the phone\n   can be A/B'd with and without them. The fx one-shots keep the stock fadeIn at index 0 of the\n   animation list (same name, same timing -> never restarted) and append a second, finite animation. */\n:global(html[data-fx='1']) .gameCard {\n  will-change: auto;\n}\n@media (prefers-reduced-motion: no-preference) {\n  :global(html[data-fx='1']) .gameCard[data-view='multi'] {\n    will-change: auto;\n  }\n}\n/* First-load reveal / view switch (shared/effects): while html[data-fx-stagger] is stamped, the first\n   8 cards of the first 3 children of the section container rise in with a 30 ms stagger. The stock\n   fadeIn keeps its exact values at index 0 (comma lists map per animation), the rise is appended. */\n:global(html[data-fx='1'][data-fx-stagger]) [data-section-container] > :nth-child(-n + 3) :nth-child(-n + 8) > .gameCard {\n  animation-name: fadeIn, fxCardRise;\n  animation-duration: 0.4s, 0.42s;\n  animation-timing-function: ease-out, cubic-bezier(0.2, 0.8, 0.2, 1);\n  animation-fill-mode: forwards, both;\n  animation-delay: 0s, calc(var(--fx-i, 0) * 30ms + 350ms);\n}\n:global(html[data-fx-stagger]) :nth-child(2) > .gameCard {\n  --fx-i: 1;\n}\n:global(html[data-fx-stagger]) :nth-child(3) > .gameCard {\n  --fx-i: 2;\n}\n:global(html[data-fx-stagger]) :nth-child(4) > .gameCard {\n  --fx-i: 3;\n}\n:global(html[data-fx-stagger]) :nth-child(5) > .gameCard {\n  --fx-i: 4;\n}\n:global(html[data-fx-stagger]) :nth-child(6) > .gameCard {\n  --fx-i: 5;\n}\n:global(html[data-fx-stagger]) :nth-child(7) > .gameCard {\n  --fx-i: 6;\n}\n:global(html[data-fx-stagger]) :nth-child(8) > .gameCard {\n  --fx-i: 7;\n}\n/* Game open (features/games/effects): press-scale, then a glow ring on ::after fades over the card. */\n:global(html[data-fx='1']) .gameCard:global(.fx-press) {\n  animation-name: fadeIn, fxPress;\n  animation-duration: 0.4s, 320ms;\n  animation-timing-function: ease-out, cubic-bezier(0.3, 0.7, 0.3, 1);\n  animation-fill-mode: forwards, none;\n  animation-delay: 0s, 0s;\n}\n:global(html[data-fx='1']) .gameCard:global(.fx-press)::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  z-index: 2;\n  border-radius: var(--border-radius-for-game-cards, 5px);\n  box-shadow: 0 0 28px 8px rgba(255, 214, 92, 0.85), inset 0 0 0 2px rgba(255, 240, 180, 0.9);\n  pointer-events: none;\n  animation: fxPressGlow 320ms ease-out both;\n}\n:global(html[data-motion-tier='lite']) .gameCard:global(.fx-press),\n:global(html[data-motion-tier='lite']) .gameCard:global(.fx-press)::after {\n  animation-duration: 0.4s, 200ms;\n}\n@keyframes fxPress {\n  0% {\n    transform: scale(1);\n  }\n  40% {\n    transform: scale(0.94);\n  }\n  100% {\n    transform: scale(1.03);\n  }\n}\n@keyframes fxPressGlow {\n  0% {\n    opacity: 0;\n  }\n  45% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n@keyframes fxCardRise {\n  from {\n    transform: translateY(12px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n/* Disable transitions during rapid switching */\n/* fallow-ignore-next-line unused-export */\n.fastSwitching .gameCard,\n.fastSwitching .gameCard * {\n  transition: none;\n}\n/* Play button - hidden by default, shown on hover */\n.playButton {\n  display: none;\n}\n/* PrizePop icon - positioned above tournament cup */\n/* fallow-ignore-next-line unused-export */\n.prizePopIcon {\n  position: absolute;\n  width: 20%;\n  top: 15%;\n  left: 2%;\n  cursor: default;\n  z-index: 5;\n  object-fit: contain;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gameCard": `SWrXvOeZtKiUY9SlGEI4`,
	"fadeIn": `hUZYmnaeybzIhvAD2rK_`,
	"horizontal": `sF7diwF0Rp9kxiM7_Uvg`,
	"badgePlate": `xxL3hJGy7llV76Q1Duk8`,
	"gameBottomContainer": `iqhQ4IVne6kk2sNJtguP`,
	"playButton": `h2jIUYo7D5eIR4uAlSZQ`,
	"gameInfoBar": `zyyCgEClZbpZLenFJvhz`,
	"hasJackpot": `W3RgBWG8kPvt7kD8qx_A`,
	"noJackpot": `bzWG7nK24YaeCjYEMAv9`,
	"fxCardRise": `ssytMS28JRKheru3h3NK`,
	"fxPress": `kwCzTGDmkPKe2uFWXQma`,
	"fxPressGlow": `B7clneUDhi8xbYCwIs2w`,
	"fastSwitching": `sKMsFHvUc_lSFCgVUOuW`,
	"prizePopIcon": `C56fT5PbkhCH9ZjEo4ZA`
};
export default ___CSS_LOADER_EXPORT___;
